<template>
  <a-modal
    title="请依次绑定答题器"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :width="1120"
    @ok="handleOk"
    @cancel="closeModal"
  >
    <template slot="footer">
      <div class="footer-box">
        <div class="search-input">
          <img :src="require('@/assets/common/search-magnifying-glass.png')" alt="" />
          <input v-model="searchValue" type="text" placeholder="输入设备ID搜索" />
        </div>
        <div class="footer-btn-box">
          <div class="cancel-btn" @click="closeModal">取消</div>
          <div class="confirm-btn" @click="handleOk">确认</div>
        </div>
      </div>
    </template>
    <div class="equipment-box">
      <div v-for="(equipment, index) in filteringAnsweringMachine" :key="index" class="equipment-item">
        <div class="name">
          <span style="margin-right: 5px; line-height: 28px">ID:</span>
          {{ showId(equipment.id) }}
        </div>
        <div class="success-equipment-item-box" @click.stop="unbind(index)">
          <div class="icon-box">
            <img class="icon" :src="require('@/assets/bind-dtq/unbind.png')" />
          </div>
          <span>解除绑定</span>
        </div>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { receiverBatchBindDTQ, searchByReceiver } from '@/api/common'
import { sendMessage } from '@/utils/dtq'

export default {
  name: 'BindDTQModal',
  data() {
    return {
      visible: false,
      receiverId: localStorage.getItem('receiverId') || '',
      confirmLoading: false,
      searchValue: '',
      answeringMachine: [],
      copyAnsweringMachine: [],
      deleteDataId: new Set()
    }
  },
  computed: {
    filteringAnsweringMachine() {
      return this.answeringMachine.filter(item => {
        const showId = item.id.toString().length > 6 ? item.id.toString().slice(-6) : item.id.toString()
        return showId.includes(this.searchValue)
      })
    }
  },
  watch: {
    visible(val) {
      val ? sendMessage({ fun: 'get_dev_info' }) : null
    }
  },
  mounted() {
    this.$bus.$on('dtqMessage', this.handleDTQMessage)
  },
  destroyed() {
    this.$bus.$off('dtqMessage', this.handleDTQMessage)
  },
  methods: {
    openModal() {
      this.visible = true
    },

    closeModal() {
      this.visible = false
      this.answeringMachine = []
      this.copyAnsweringMachine = []
    },

    handleOk() {
      this.handleReceiverBatchBindDTQ()
    },

    async handleDTQMessage(data) {
      if (data.fun === 'get_wl_list' && data.dev_sn && this.visible) {
        this.receiverId = data.dev_sn
        localStorage.setItem('receiverId', data.dev_sn)
        this.getAnsweringMachineList(data.dev_sn)
      }
      const uidTypes = [18, 98, 4]
      if (data.fun === 'card_update' && uidTypes.includes(data.uID_t)) {
        console.log('card_update', data)
        if (
          this.answeringMachine.map(item => item.id).includes(data.uID) ||
          this.answeringMachine.map(item => item.id).includes(String(data.uID))
        ) {
          return this.visible ? this.$message.error('该答题器已绑定') : null
        }
        this.answeringMachine.push({
          id: String(data.uID),
          type: String(data.uID_t),
          seq: this.answeringMachine.length ? this.answeringMachine.length + 1 : 1
        })
      }
    },

    showId(id) {
      return String(id).length > 6 ? String(id).slice(-6) : String(id)
    },

    getAnsweringMachineList(id) {
      if (!id) id = this.receiverId
      searchByReceiver({ receiverId: id }).then(res => {
        this.answeringMachine = res.data.map(item => {
          return {
            id: String(item.answerMachineId),
            type: String(item.answerMachineTypeId),
            seq: item.seq
          }
        })
        this.copyAnsweringMachine = this.answeringMachine
      })
    },

    async unbind(index) {
      const unbindMachine = this.filteringAnsweringMachine[index]
      const currentIndex = this.answeringMachine.findIndex(item => item.id === unbindMachine.id)
      if (currentIndex !== -1) {
        // sendMessage({ fun: 'clear_wl', uID: unbindMachine.id })
        this.deleteDataId.add(unbindMachine.id)
        this.answeringMachine.splice(currentIndex, 1)
      } else {
        this.$message.error('答题器不存在')
        this.searchValue = ''
        this.getAnsweringMachineList()
      }
    },

    handleReceiverBatchBindDTQ() {
      if (this.deleteDataId.size) {
        Array.from(this.deleteDataId).forEach(id => {
          if (!this.answeringMachine.map(item => item.id).includes(id)) {
            sendMessage({ fun: 'clear_wl', uID: id })
          }
        })
      }
      const answerMachineIds = this.answeringMachine.map(item => item.id)
      const answerMachineTypeId = this.answeringMachine[0]?.type || '18'
      const params = {
        userId: this.$store.getters.userId,
        answerMachineIds,
        receiverId: this.receiverId,
        answerMachineTypeId
      }
      receiverBatchBindDTQ(params).then(res => {
        if (res.state === 11) {
          if (!this.answeringMachine.length) {
            this.$message.success('解绑成功')
          } else {
            this.$message.success('更改绑定成功')
          }
          this.closeModal()
          this.$emit('confirm')
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.equipment-box {
  display: flex;
  row-gap: 20px;
  column-gap: 20px;
  flex-wrap: wrap;
  height: 529px;
  align-content: baseline;
  overflow-y: scroll;
  .equipment-item {
    width: 180px;
    height: 80px;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #e5e5e5;
    display: flex;
    align-items: center;
    position: relative;
    font-size: 20px;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
    overflow: hidden;
    white-space: nowrap;
    text-align: center;
    cursor: pointer;

    .success-equipment-item-box {
      display: none;
      width: 100%;
      height: 100%;
      position: absolute;
      color: #ffffff;
      align-items: center;
      font-size: 20px;

      .icon-box {
        width: 50px;
        height: 50px;
        margin-left: 20px;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;

        .icon {
          width: 30px;
          height: 30px;
        }
      }
    }

    .name {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &:hover {
      background: rgba(0, 0, 0, 0.7);
      border: none;
      color: inherit;

      .success-equipment-item-box {
        display: flex;
      }
    }

    &.error {
      color: #ff3c30;
      border: 1px solid #ff3c30;
    }

    &:hover {
      box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.08);
    }
  }
}

.footer-box {
  height: 69px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .search-input {
    margin-left: 24px;
    display: flex;
    align-items: center;
    padding: 13px 20px;
    width: 286px;
    height: 46px;
    background: #f6f6f6;
    border-radius: 8px;
    border: 1px solid #e5e5e5;
    img {
      width: 20px;
      height: 20px;
    }
    input {
      width: 100%;
      height: 100%;
      border: none;
      outline: none;
      margin-left: 8px;
      font-weight: 400;
      font-size: 18px;
      color: #333333;
      line-height: 25px;
      background-color: #f6f6f6;
      &::placeholder {
        font-weight: 400;
        font-size: 18px;
        color: #999999;
        line-height: 25px;
      }
    }
  }
}
.footer-btn-box {
  display: flex;
  margin-right: 24px;
}
.cancel-btn {
  width: 150px;
  height: 46px;
  background: #ffffff;
  border-radius: 100px;
  border: 1px solid #1976ff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 28px;
  color: #1976ff;
  &.red {
    color: #ff3c30;
    border-color: #ff3c30;
  }
  &:hover {
    background: #f6f6f6;
  }
  &:active {
    background: #f6f6f6;
  }
}
.confirm-btn {
  width: 180px;
  height: 46px;
  background: linear-gradient(270deg, #66adff 0%, #1976ff 100%);
  color: #ffffff;
  border-radius: 100px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  &.bound {
    background: linear-gradient(270deg, #66adff 0%, #1976ff 100%);
    color: #ffffff;
  }
  &:hover {
    color: #ffffff;
    background: #0565f3;
  }
  &:active {
    color: #ffffff;
    background: #0565f3;
  }
}

::v-deep .ant-modal-content {
  border-radius: 24px;
  .ant-modal-header {
    height: 72px;
    display: flex;
    align-items: center;
    border-radius: 24px 24px 0 0;
  }
  .ant-modal-close-x {
    width: 72px;
    height: 72px;
    line-height: 72px;
  }
  .anticon {
    &:hover {
      padding: 15px;
      background: #f6f6f6;
      border-radius: 50%;
    }
  }
}
</style>
